import React from "react";
import { useNavigate } from "react-router-dom";
import { TaskStatus } from "../../../__generated__/globalTypes";
import { useToggleTask } from "../hooks";
import { TaskPriorityBadge } from "./task-priority-badge";
import { formatDisplayDate } from "../../../helpers/date";

interface ITask {
  id: number;
  title: string;
  status: TaskStatus;
  priority: any;
  dueDate?: string | null;
  user?: { id: number; firstname: string; lastname: string } | null;
}

interface IProps {
  task: ITask;
  showOwner?: boolean;
  onChanged?: () => void;
}

export const TaskItem: React.FC<IProps> = ({ task, showOwner, onChanged }) => {
  const navigate = useNavigate();
  const { toggle, loading } = useToggleTask();
  const isDone = task.status === TaskStatus.Done;

  const handleToggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await toggle(task.id, task.status);
    onChanged?.();
  };

  return (
    <div
      className="flex items-center gap-3 py-2 px-1 border-b border-gray-100 last:border-b-0 cursor-pointer hover:bg-gray-50"
      onClick={() => navigate(`/task/${task.id}`)}
    >
      <input
        type="checkbox"
        checked={isDone}
        disabled={loading}
        onClick={handleToggle}
        onChange={() => {}}
        className="cursor-pointer"
      />
      <div className="flex-1 min-w-0">
        <p
          className={`text-sm truncate ${
            isDone ? "line-through text-gray-400" : "text-gray-900"
          }`}
        >
          {task.title}
        </p>
        {showOwner && task.user && (
          <p className="text-xs text-gray-500">
            {task.user.firstname} {task.user.lastname}
          </p>
        )}
      </div>
      {task.dueDate && (
        <span className="text-xs text-gray-500 whitespace-nowrap">
          {formatDisplayDate(task.dueDate)}
        </span>
      )}
      <TaskPriorityBadge priority={task.priority} />
    </div>
  );
};
